import React from "react"
import { useTranslation } from "providers/i18n"

import { Box, IconButton, InputBase, Divider, useTheme } from "@mui/material"
import ImportExportIcon from "@mui/icons-material/ImportExport"
import MoreVertIcon from "@mui/icons-material/MoreVert"

import {
  ArrowLeftIcon,
  DestinationMarkerIcon,
  OriginMarkerIcon,
  CloseIcon,
} from "components/icons"

const ClearButton = ({ sx, onClick = () => {}, show = false, ...props }) => {
  return (
    <IconButton
      size="small"
      sx={{ ...sx, visibility: show ? "visible" : "hidden" }}
      onClick={onClick}
      {...props}
    >
      <CloseIcon />
    </IconButton>
  )
}
export const DirectionSearch = (props) => {
  const theme = useTheme()
  const {
    directionSearchWrapper,
    backIconWrapper,
    directionWrapper,
    switchIconWrapper,
    directionInputWrapper,
    directionIconWrapper,
    directionInput,
    iconButton,
    divider,
    clearIconButton,
  } = theme.components[`DirectionSearchComponent`]?.styleOverrides || {}
  const { t } = useTranslation()
  const {
    onBack = () => {},
    onSwitch = () => {},
    onOriginChange = () => {},
    onDestinationChange = () => {},
    onOriginFocus = () => {},
    onDestinationFocus = () => {},
    onClick = () => {},
    originInputRef,
    destinationInputRef,
    onClearDestination = () => {},
    onClearOrigin = () => {},
    ...res
  } = props

  const showOriginClearButton = originInputRef?.current?.value
  const showDestinationClearButton = destinationInputRef?.current?.value

  return (
    <Box sx={directionSearchWrapper} onClick={onClick}>
      <Box sx={backIconWrapper}>
        <IconButton
          aria-label="back"
          size="small"
          onClick={onBack}
          sx={iconButton}
        >
          <ArrowLeftIcon fontSize="inherit" />
        </IconButton>
      </Box>

      <Box sx={directionWrapper}>
        <Box sx={directionIconWrapper}>
          <OriginMarkerIcon fontSize="small" />
          <MoreVertIcon color="disabled" fontSize="small" />
          <DestinationMarkerIcon color="error" fontSize="small" />
        </Box>
        <Box sx={directionInputWrapper}>
          <InputBase
            placeholder={t("Choose your origin")}
            onChange={onOriginChange}
            onFocus={onOriginFocus}
            inputRef={originInputRef}
            sx={directionInput}
            {...res}
            endAdornment={
              <ClearButton
                aria-label="clear-origin"
                show={showOriginClearButton}
                sx={clearIconButton}
                onClick={onClearOrigin}
              />
            }
          />

          <Divider sx={divider} />
          <InputBase
            placeholder={t("Choose your destination")}
            onChange={onDestinationChange}
            onFocus={onDestinationFocus}
            inputRef={destinationInputRef}
            sx={directionInput}
            {...res}
            endAdornment={
              <ClearButton
                aria-label="clear-destination"
                show={showDestinationClearButton}
                sx={clearIconButton}
                onClick={onClearDestination}
              />
            }
          />
        </Box>
      </Box>

      <Box sx={switchIconWrapper}>
        <IconButton
          aria-label="switch"
          size="small"
          onClick={onSwitch}
          sx={iconButton}
        >
          <ImportExportIcon fontSize="inherit" />
        </IconButton>
      </Box>
    </Box>
  )
}
